import { Outlet } from 'react-router-dom';
import SideNav from './SideNav';

const AppLayout = () => (
  <div className="flex h-screen flex-col overflow-hidden bg-[#050815] text-slate-100 md:flex-row">
    <SideNav />
    <main className="flex-1 min-w-0 overflow-hidden pt-3 md:pt-0">
      <Outlet />
    </main>
  </div>
);

export default AppLayout;
